import { Injectable } from '@angular/core';
import { OrderformOrderState, PAYMENT_ERROR_MESSAGES } from '../../../ngrx/orderform.models';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorMessageService {
  public getCustomErrorMessageFromOrderData(result: any, orderData: OrderformOrderState): string {
    const paymentErrorMessagesMapping = orderData?.order?.payment_provider?.payment_error_messages_mapping;
    if (!paymentErrorMessagesMapping) {
      return this._getDefaultOrOriginalMessage(result);
    }

    const errorCode = this._extractErrorCode(result);
    if (!errorCode) {
      return this._getDefaultOrOriginalMessage(result);
    }

    if (paymentErrorMessagesMapping.hasOwnProperty(errorCode)) {
      const paymentErrorIdentifier = paymentErrorMessagesMapping[errorCode];
      const improvedErrorMessage = this._translateErrorMessage(paymentErrorIdentifier);

      if (improvedErrorMessage && improvedErrorMessage.trim() !== '') {
        return improvedErrorMessage;
      }
    }

    return this._getDefaultOrOriginalMessage(result);
  }

  private _extractErrorCode(result: any): string | null {
    if (!result || !result.error) {
      return null;
    }

    const possibleCodeProps = [
      'decline_code', // Stripe decline code
      'code',
      'error_code',
      'errorCode',
    ];

    for (const prop of possibleCodeProps) {
      if (result.error[prop]) {
        return result.error[prop];
      }
    }

    if (typeof result.error === 'string' || typeof result.error === 'number') {
      return result.error.toString();
    }

    return null;
  }

  private _getDefaultOrOriginalMessage(result: any): string {
    if (result?.error?.message) {
      return result.error.message;
    }

    return $localize`:@@payment_method.error.generic:Die Zahlung konnte jetzt nicht verarbeitet werden. Bitte probieren es mit einer anderen Bezahlweise nochmal.`;
  }

  private _translateErrorMessage(paymentErrorIdentifier: string) {
    return (
      PAYMENT_ERROR_MESSAGES[paymentErrorIdentifier] ||
      $localize`:@@payment_method.error.generic:Die Zahlung konnte jetzt nicht verarbeitet werden. Bitte probieren es mit einer anderen Bezahlweise nochmal.`
    );
  }
}
